import { useEffect, useState } from "react";
import { onAuthStateChanged, type User } from "firebase/auth";
import { HEARTBEAT_INTERVAL_MS } from "radio-shared";
import { api } from "../api";
import { auth } from "../firebase";

export function useAuth(): { user: User | null; checking: boolean } {
  const [user, setUser] = useState<User | null>(null);
  const [checking, setChecking] = useState(true);

  useEffect(
    () =>
      onAuthStateChanged(auth, (u) => {
        setUser(u);
        setChecking(false);
      }),
    [],
  );

  /** Signale sa présence tant que l'onglet est ouvert : c'est ce qui alimente la
   *  liste des auditeurs et le seuil de skip. */
  useEffect(() => {
    if (!user) return;
    const beat = () => void api.heartbeat().catch(() => undefined);
    beat();
    const timer = setInterval(beat, HEARTBEAT_INTERVAL_MS);
    return () => clearInterval(timer);
  }, [user]);

  return { user, checking };
}
